import {WebSvg} from '@/assets';
import {Button} from '@/components/common';

import {Link} from 'react-router-dom';

const NotFoundError = ({to}: {to: string}) => {
  return (
    <div className="w-100 ">
      <div className="d-flex justify-content-center align-items-center my-5 flex-column page-not-found-part">
        <img src={WebSvg.NotFoundIcon} />
        <h1 className="mt-3">404</h1>
        <p className="text-center w-75">
          It seems like the page you are looking for does not exist
        </p>
        <Link to={to}>
          <Button>Go to Home</Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundError;
